import React, { useEffect, useState } from 'react';
import {
  TreeView,
  TreeNode,
  DataTable,
  TextInput,
  Select,
  SelectItem,
  FileUploaderDropContainer,
  NumberInput,
  Button,
  RadioButtonGroup, RadioButton,
  OverflowMenu,
  OverflowMenuItem,
  Table, TableHead, TableRow, TableBody, TableHeader, TableSelectAll, TableSelectRow
} from '@carbon/react';
import { ChevronDown } from '@carbon/icons-react'
import './PanelsLayout.scss';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { loadFileQueuerLocationContent, loadFileQueuerLocations, loadTasks, selectFileQueuerContent, selectOneGUITasks, selectQueuerLocations, selectSelectedFileQueuerLocation, selectSelectedFileQueuerPath, selectToken, setSelectedFileQueuerLocation, setSelectedFileQueuerPath, submitFileQueuerJob } from '../../../AppSlice';
import Icon from '../../Icon/Icon';
import { HistoryModal } from './HistoryModal';
import { IFileQueuerLocationContent } from './FileQueuer.model';
import FQTree from './FQTree';
import fileSize from 'filesize';
import FileConfigs from './FileConfigs';


// const rows = [
//   {
//     id: '1',
//     thumbnail: 'https://fastly.picsum.photos/id/866/200/300.jpg?hmac=rcadCENKh4rD6MAp6V_ma-AyWv641M4iiOpe1RyFHeI',
//     filename: 'file1.extension',
//     text: '',
//     select: 'Option 1',
//     size: '219.02 MB',
//   },
//   {
//     id: '2',
//     thumbnail: 'https://fastly.picsum.photos/id/1026/200/300.jpg?blur=5&hmac=BuLVPE3Ueykm1FpDl35Q113f2LqdeQUaDmZE9-GRqKo',
//     filename: 'file2.extension',
//     text: '',
//     select: 'Option 2',
//     size: '102.56 MB',
//   },
// ];

const headers = [
  { key: 'thumbnail', header: '' },
  { key: 'filename', header: 'Filename' },
  // { key: 'text', header: 'Text' },
  // { key: 'select', header: 'Select' },
  { key: 'size', header: 'File Size' },
];


const FileQueuer: React.FC = () => {

  const dispatch = useAppDispatch()


  // const [filterStatus, setFilterStatus] = useState<string>('All');
  // const [currentPage, setCurrentPage] = useState(1);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showHistory, setShowHistory] = useState(false);
  const [tableSelectedRows, setSelectedRows] = useState([])
  // const tasks = useAppSelector(selectOneGUITasks)
  const token = useAppSelector(selectToken)

  // const filteredTasks = filterStatus === 'All'
  //   ? tasks
  //   : tasks.filter((task) => task.status.toLowerCase() === filterStatus.toLowerCase());


  // const totalItems = filteredTasks.length;
  // const startIndex = (currentPage - 1) * rowsPerPage;
  // const endIndex = startIndex + rowsPerPage;
  // const paginatedTasks = filteredTasks.slice(startIndex, endIndex);
  const locations = useAppSelector(selectQueuerLocations);
  const selectedLocation = useAppSelector(selectSelectedFileQueuerLocation);
  const files = useAppSelector(selectFileQueuerContent)
  const selectedPath = useAppSelector(selectSelectedFileQueuerPath)

  useEffect(() => {
    if (token) {
      dispatch(loadFileQueuerLocations({ token, page: 1, size: 20 }))
    }
  }, [token])

  useEffect(() => {
    if (token) {
      dispatch(loadFileQueuerLocationContent({ token, resourceId: selectedLocation, path: selectedPath }))
    }
  }, [selectedLocation, selectedPath])

  // const rows = filteredTasks.map((task) => ({ id: task.id, ...task }));


  const onActionClick = (action) => {

  }

  const onHistoryClick = () => {
    setShowHistory(true)
  }

  const onLocationChanged = (resourceId) => {
    dispatch(setSelectedFileQueuerPath("/"))
    dispatch(setSelectedFileQueuerLocation(resourceId))
    dispatch(loadFileQueuerLocationContent({ token, resourceId }))
  }

  const mapFile = (file: IFileQueuerLocationContent) => {
    return {
      id: file.name,
      thumbnail: 'https://fastly.picsum.photos/id/866/200/300.jpg?hmac=rcadCENKh4rD6MAp6V_ma-AyWv641M4iiOpe1RyFHeI',
      filename: file.name,
      text: file.relativePath,
      // select: 'Option 1',
      size: file.size,
    }
  }

  return (<>
    <div className="status-filters">
      {/* <div
        className={`action-box action-log`}
        onClick={() => onActionClick('logs')}
      >
        <Icon type='newFolder' color='white' size={18} />
        <div style={{ fontSize: 16, marginTop: 5 }}>
          New Queue
        </div>
      </div> */}
      <div
        className={`action-box action-log`}
        onClick={() => onHistoryClick()}
      >
        <Icon type='text' color='white' size={16} />
        <div style={{ fontSize: 13, marginTop: 2 }}>
          History
        </div>
      </div>
    </div>
    <div className="panels-container">
      <div className="panel panel-1">
        <div className="panel-header" style={{ padding: 10 }}>
          <div style={{ padding: 10 }}>Select Folder</div>
          <div >
            <span style={{ padding: 10 }}>Choose Resource </span>
            <span>
              <OverflowMenu aria-label="overflow-menu" size="sm" renderIcon={ChevronDown}>
                <OverflowMenuItem style={selectedLocation === null ? { backgroundColor: "rgba(255,255,0,0.3)" } : {}} itemText="Choose..." onClick={() => dispatch(setSelectedFileQueuerLocation(null))} />
                {locations?.map(location => <OverflowMenuItem key={"loc_sel" + location.id} style={selectedLocation === location.id ? { backgroundColor: "rgba(255,255,0,0.3)" } : {}} onClick={e => onLocationChanged(location.id)} itemText={location.label} />)}
              </OverflowMenu>
            </span>
          </div>
        </div>
        <div className="panel-content">
          <FQTree
            key={"file-queuer-tree" + selectedLocation + selectedPath}
            selectedLocation={selectedLocation}
            selectedPath={selectedPath}
            content={files["root"] ?? []}
            onSelect={path => {
              dispatch(setSelectedFileQueuerPath(path))
            }}
            locations={locations} />
        </div>
      </div>

      {/* Panel 2: Table */}
      <div className="panel panel-2">
        <div className="panel-header">
          <div>Folder Content : <strong>{selectedPath ?? "Root"}</strong></div>
          <div>
            <RadioButtonGroup
              name="radio-group"
            // valueSelected={selected}
            // onChange={(value) => setSelected(value)}
            >
              <RadioButton id="option-1" labelText="None" value="option-1" />
              <RadioButton id="option-2" labelText="Group" value="option-2" />
              <RadioButton id="option-3" labelText="Stitch" value="option-3" />
            </RadioButtonGroup>

          </div>
        </div>
        <div className="panel-content" style={{ padding: 0 }}>
          <DataTable
            rows={files[selectedPath ?? "root"]?.filter(files => !files.isDirectory).map(mapFile) ?? []}
            headers={headers}
            isSortable
            render={({ rows, headers, getHeaderProps, getRowProps, getTableProps, getSelectionProps, selectedRows }) => {

              if (JSON.stringify(selectedRows.map(w => w.id)) !== JSON.stringify(tableSelectedRows)) {
                setSelectedRows(selectedRows.map(w => w.id));
              }

              return <Table {...getTableProps()}>
                <TableHead>
                  <TableRow>
                    {/* <TableExpandHeader {...getExpandHeaderProps()} /> */}
                    <TableSelectAll {...getSelectionProps()} />
                    {headers.map((header) => (
                      <TableHeader key={header.key} {...getHeaderProps({ header })}>
                        {header.header}
                      </TableHeader>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <TableRow key={row.id} {...getRowProps({ row })}>
                      <TableSelectRow {...getSelectionProps({ row })} />
                      {row.cells.map((cell) => {
                        if (cell.info.header === 'thumbnail') {
                          return (
                            <td key={cell.id} style={{ backgroundImage: `url(${cell.value})`, backgroundSize: "cover", height: 40, width: 40 }}></td>
                          );
                        }
                        if (cell.info.header === 'filename') {
                          return (
                            <td key={cell.id} style={{ padding: 10 }}>{cell.value}</td>
                          );
                        }
                        if (cell.info.header === 'size') {
                          return (
                            <td key={cell.id} style={{ width: "15%", textAlign: "center" }}>{fileSize(cell.value)}</td>
                          );
                        }
                        return <td key={cell.id} style={{ padding: 10 }}>{cell.value}</td>
                        // if (cell.key === 'text') {
                        //   return (
                        //     <td key={cell.id} style={{ padding: 10 }}>{cell.value}</td>
                        //   );
                        // }
                      })}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            }}
          />

          {/* <td style={{ backgroundImage: `url(${row.cells[0].value})`, backgroundSize: "cover", height: 40, width: 40 }} >

                      </td>
                      <td style={{ padding: 10 }}>{row.cells[1].value}</td> 
                      <td style={{ width: "15%", textAlign: "center" }}>{fileSize(row.cells[4].value)}</td>
                      */}


          {/* </DataTable> */}
        </div>
      </div>

      {/* Panel 3: Configuration Form */}
      <div className="panel panel-3">
        <div className="panel-header">Configuration</div>
        <div style={{ padding: 20, paddingBottom: 0 }}>
          {tableSelectedRows?.length > 0 ? ("Selected Files: " + tableSelectedRows.length) : "No files selected"}
        </div>
        {tableSelectedRows?.length > 0 ? <FileConfigs
        onSubmit={(fileQueuerConfigs) => {
          let loc = selectedPath && selectedPath !== "/" ? (selectedPath + "/" ) : ""
          tableSelectedRows.forEach(file => {
            const configs = {
              ...fileQueuerConfigs,
              file: loc + file,
              resourceId: selectedLocation,
            }
            dispatch(submitFileQueuerJob({ token, fileQueuerJob: configs }));
            console.log("File Queuer Configs Submitted: ", configs);
          });
        }}
        /> : null }
      </div>
    </div>

    <HistoryModal
      open={showHistory}
      onClose={() => setShowHistory(false)}
    />
  </>
  );
};

export default FileQueuer;
